var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTimelinePremiumContributionPurpose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.741c2.28 0 4-1.72 4-4 0-2.28-1.72-4-4-4-2.28 0-4 1.72-4 4 0 2.28 1.72 4 4 4zm0-6c1.178 0 2 .822 2 2s-.822 2-2 2-2-.822-2-2 .822-2 2-2zm1 7H7c-2.757 0-5 2.243-5 5v1h2v-1c0-1.654 1.346-3 3-3h2c1.654 0 3 1.346 3 3v1h2v-1c0-2.757-2.243-5-5-5zm9.364-10.364L16.95 4.791A6.962 6.962 0 0119 9.74a6.962 6.962 0 01-2.05 4.95l1.414 1.414A8.944 8.944 0 0021 9.741a8.944 8.944 0 00-2.636-6.364z",
    fill: "gray"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.535 6.205L14.121 7.62c.567.565.88 1.318.88 2.12s-.313 1.555-.88 2.12l1.414 1.416A4.967 4.967 0 0017 9.74a4.967 4.967 0 00-1.465-3.536z",
    fill: "gray"
  })));
}

export default SvgIconTimelinePremiumContributionPurpose;